import { SettingsContext } from "@redotech/redo-customer-portal-app/contexts/settings";
import { Orders as OrdersNew } from "@redotech/redo-customer-portal-app/portal-four/orders/orders";
import { useContext } from "react";
import { Orders } from "./orders";

export function OrdersDispatch() {
  const settings = useContext(SettingsContext);

  if (settings?.returns?.newLogin) {
    return <OrdersNew registerOnly={false} />;
  }

  return <Orders />;
}
